<nav class="sidebar">
  <div class="sidebar-header">
    <a class="sidebar-brand" [routerLink]="['/smartdocs/filer-summary']">
      <div class="brand-logo-poc">
        <!-- <div class="brand-logo-wrap"> -->
        <img src="assets/MI-logo2.png" class="brand-logo-img" />
        <!-- </div> -->
        <!-- <div class="logo-pulse"></div -->
      </div>
      <div class="brand-titles-poc">
        <span class="brand-text">Flint<br /><span class="brand-highlight">Housing</span></span>
      </div>
    </a>
    <div class="sidebar-toggler" #sidebarToggler (click)="toggleSidebar($event)">
      <span></span>
      <span></span>
      <span></span>
    </div>
  </div>

  <div class="sidebar-body">
    <ng-scrollbar orientation="vertical" appearance="compact">
      <ul class="sidebar-nav metismenu" id="sidebar-menu">

        <!-- ─── MAIN MENU ─── -->
        <!--<li class="nav-category">MAIN MENU</li>-->
        <!--<li class="nav-item">
    <a class="nav-link"
       [routerLink]="'/smartdocs/smartdocs-dashboard'"
       routerLinkActive="active"
       [routerLinkActiveOptions]="{exact: false}"
       matTooltip="Dashboard"
       [matTooltipDisabled]="!isSidebarFolded"
       matTooltipPosition="right">
      <span class="link-icon-wrap">
        <i class="link-icon" data-feather="pie-chart" appFeatherIcon></i>
      </span>
      <span class="link-title">Dashboard</span>
    </a>
  </li>-->
        <!-- ─── DOCUMENTS ─── -->
        <!--<li class="nav-category">DOCUMENTS</li>

  <li class="nav-item">
    <a class="nav-link"
       [routerLink]="'/smartdocs/doc-extract'"
       routerLinkActive="active"
       [routerLinkActiveOptions]="{exact: false}"
       matTooltip="Documents"
       [matTooltipDisabled]="!isSidebarFolded"
       matTooltipPosition="right">
      <span class="link-icon-wrap">
        <i class="link-icon" data-feather="file-plus" appFeatherIcon></i>
      </span>
      <span class="link-title">Documents</span>
    </a>
  </li>-->
        <li class="sidebar-logo-container">
          <img src="assets/images/xtractiq-logo.png" class="sidebar-logo-img" alt="XtractIQ Logo">
        </li>
        <li class="nav-category">DOCUMENTS</li>
        <!-- <li class="nav-item">
          <a class="nav-link" [routerLink]="'/smartdocs/folders'" routerLinkActive="active"
            [routerLinkActiveOptions]="{exact: false}" matTooltip="Folders" [matTooltipDisabled]="!isSidebarFolded"
            matTooltipPosition="right">
            <span class="link-icon-wrap">
              <i class="link-icon" data-feather="folder" appFeatherIcon></i>
            </span>
            <span class="link-title">Documents</span>
          </a>
        </li> -->
        <li class="nav-item">
          <a class="nav-link" [routerLink]="'/smartdocs/filer-summary'" routerLinkActive="active"
            [routerLinkActiveOptions]="{exact: false}" matTooltip="Filer Summary"
            [matTooltipDisabled]="!isSidebarFolded" matTooltipPosition="right">
            <span class="link-icon-wrap">
              <i class="link-icon" data-feather="users" appFeatherIcon></i>
            </span>
            <span class="link-title">Summary</span>
          </a>
        </li>
        <!-- ─── Reports ─── -->
        <!--<li class="nav-category">REPORTS</li>
  <li class="nav-item">
    <a class="nav-link"
       [routerLink]="'/smartdocs/reports'"
       routerLinkActive="active"
       [routerLinkActiveOptions]="{exact: false}"
       matTooltip="Knowledge Base"
       [matTooltipDisabled]="!isSidebarFolded"
       matTooltipPosition="right">
      <span class="link-icon-wrap">
        <i class="link-icon" data-feather="book" appFeatherIcon></i>
      </span>
      <span class="link-title">Reports</span>
    </a>
  </li>-->
        <!-- ─── RESOURCES ─── -->
        <!--<li class="nav-category">RESOURCES</li>

  <li class="nav-item">
    <a class="nav-link"
       [routerLink]="'/smartdocs/knowledge-base'"
       routerLinkActive="active"
       [routerLinkActiveOptions]="{exact: false}"
       matTooltip="Knowledge Base"
       [matTooltipDisabled]="!isSidebarFolded"
       matTooltipPosition="right">
      <span class="link-icon-wrap">
        <i class="link-icon" data-feather="book" appFeatherIcon></i>
      </span>
      <span class="link-title">Knowledge Base</span>
    </a>
  </li>-->

      </ul>
    </ng-scrollbar>
  </div>
</nav>